import React, { useEffect, useRef } from 'react';

const AddressAutocomplete = ({
  value,
  onChange,
  onAddressSelect,
  placeholder = "Start typing address...",
  className = "",
  required = false,
  disabled = false
}) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.warn('Google Maps API not loaded yet');
      return;
    }

    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ['address'],
      componentRestrictions: { country: 'us' },
      fields: ['address_components', 'formatted_address', 'geometry']
    });

    autocompleteRef.current = autocomplete;

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();

      if (!place || !place.address_components) {
        console.warn('No address components');
        return;
      }

      const addressData = {
        street: '',
        city: '',
        state: '',
        county: '',
        zip: '',
        fullAddress: place.formatted_address || ''
      };

      place.address_components.forEach((component) => {
        const types = component.types;

        if (types.includes('street_number')) {
          addressData.street = component.long_name + ' ';
        }
        if (types.includes('route')) {
          addressData.street += component.long_name;
        }
        if (types.includes('locality')) {
          addressData.city = component.long_name;
        }
        if (types.includes('administrative_area_level_1')) {
          addressData.state = component.short_name; // Use short name for state abbreviation
        }
        if (types.includes('administrative_area_level_2')) {
          // Remove "County" suffix if present
          addressData.county = component.long_name.replace(' County', '');
        }
        if (types.includes('postal_code')) {
          addressData.zip = component.long_name;
        }
      });

      console.log('Address selected:', addressData);

      // Call onAddressSelect first to update all fields
      if (onAddressSelect) {
        onAddressSelect(addressData);
      }

      // Then update just the street address field after a small delay
      // This ensures the parent state updates first
      setTimeout(() => {
        if (onChange && addressData.street) {
          onChange(addressData.street);
        }
      }, 0);
    });

    return () => {
      if (autocompleteRef.current && window.google?.maps?.event) {
        window.google.maps.event.clearInstanceListeners(autocompleteRef.current);
      }
    };
  }, [onAddressSelect, onChange]);

  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <input
      ref={inputRef}
      type="text"
      value={value || ''}
      onChange={handleChange}
      placeholder={placeholder}
      className={className}
      required={required}
      disabled={disabled}
      autoComplete="off"
    />
  );
};

export default AddressAutocomplete;
